module.exports = __webpack_public_path__ + "img/logo_apidat.b45d8724.jpg";